import { VuexModule, Action } from "vuex-class-modules";
import { BaseParentDocumentService } from "@/services/BaseDocumentService";
import _ from "lodash";
import { globalStore } from "@/store/modules/GlobalStore";
import { BaseDocument } from "@/models/BaseDocuments";

export abstract class BaseParentDocumentStore<
  TEntity extends BaseDocument,
  TService extends BaseParentDocumentService<TEntity>
> extends VuexModule {
  abstract current: TEntity;
  abstract newEntity(): TEntity;
  abstract get service(): TService;
  entities: TEntity[] = [];

  @Action
  async getAll(): Promise<void> {
    try {
      globalStore.setIsBusy(true);
      const items = await this.service.getAll();
      this.entities = items.map((x) => _.merge(this.newEntity(), x));
    } finally {
      globalStore.setIsBusy(false);
    }
  }
  @Action
  new(): void {
    this.current = this.newEntity();
  }

  @Action
  async select(id: string): Promise<void> {
    const entity = this.newEntity();
    const data = await this.service.get(id);
    _.merge(entity, data);
    this.current = entity;
  }
}
